"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FeedbackSubmissionRecord = _interopRequireDefault(require("customer-data-objects/feedback/FeedbackSubmissionRecord"));

var _react = require("react");

var FeedbackSubmissionType = _react.PropTypes.instanceOf(_FeedbackSubmissionRecord.default);

var _default = FeedbackSubmissionType;
exports.default = _default;
module.exports = exports.default;